/** The AI debug panel's model call list (staff only). */
export const translationsDashboard_en_aiModelCalls = {
  aiModelCallsTitle: "Model calls",
  aiModelCallsLoading: "Loading model calls",
  aiModelCallsError: "Could not load the model calls.",
  aiModelCallsEmpty: "No model calls recorded for this message. Calls are kept for 30 days.",
  aiModelCallFallback: "Fallback",
  aiModelCallTokensIn: "In",
  aiModelCallTokensOut: "Out",
  aiModelCallTokensCached: "Cached",
  aiModelCallLoading: "Loading call",
  aiModelCallError: "Could not load this call.",
  aiModelCallTruncated:
    "The stored content was shortened: {{instruction}} characters were cut from the end of the instruction and {{response}} from the response.",
  aiModelCallInstruction: "Instruction",
  aiModelCallCopyInstruction: "Copy instruction",
  aiModelCallInput: "Input",
  aiModelCallCopyInput: "Copy input",
  aiModelCallConversation: "Conversation as sent",
  aiModelCallNoConversation: "No conversation messages were sent.",
  aiModelCallMessageUser: "User",
  aiModelCallMessageModel: "Model",
  aiModelCallResponse: "Raw response",
  aiModelCallCopyResponse: "Copy raw response",
  aiModelCallCopied: "Copied",
  aiModelCallReplayTitle: "Replay",
  aiModelCallEditInstruction: "Edit instruction",
  aiModelCallReplayInstructionLabel: "Instruction for the replay",
  aiModelCallReplayButton: "Replay",
  aiModelCallReplaying: "Replaying...",
  aiModelCallReplayRateLimited: "Too many replays. You can replay 10 calls a minute and 200 a day.",
  aiModelCallReplayTooLong: "The instruction is too long to replay (at most 400,000 characters).",
  aiModelCallReplayUnsupported: "Replay is not available for AWS Bedrock calls.",
  aiModelCallReplayFailed: "The replay failed. Try again later.",
  aiModelCallOriginalResponse: "Original raw response",
  aiModelCallReplayAnswer: "New answer",
  aiModelCallCopyReplayAnswer: "Copy new answer",
  aiModelCallDuration: "Time",
  aiModelCallRoleRouting: "Routing",
  aiModelCallRoleRephrase: "Rephrase",
  aiModelCallRoleMetadata: "Metadata filter",
  aiModelCallRoleLanguage: "Language detection",
  aiModelCallRoleRag: "Answer with knowledge",
  aiModelCallRoleSimple: "Simple answer",
  aiModelCallRoleImage: "Image answer",
  aiModelCallRoleSuggestion: "Suggested questions",
  aiModelCallRolePlanner: "API planner",
  aiModelCallRoleAnswer: "Answer",
};
